import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'hd-button-group',
  templateUrl: './hd-button-group.component.html',
  styleUrls: ['./hd-button-group.component.less']
})
export class HdButtonGroupComponent implements OnInit {
  @ContentChild("buttonGroupLeft", { static: false }) buttonGroupLeft: TemplateRef<any>;
  @ContentChild("buttonGroupRight", { static: false }) buttonGroupRight: TemplateRef<any>;

  constructor() { }

  ngOnInit() {

  }
}
